/**
 * Best-effort hard reload: clears Cache API entries then reloads the page.
 * Browsers do not expose true Ctrl+Shift+R bypass via script; this mirrors the intent.
 */
export async function forceRefreshPage() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    // Cache API may be unavailable or blocked
  }

  window.location.reload();
}
